import React from 'react'

const AgreementFilterBar = () => {
    return (
        <div class="filter-bar agreement-bar"><h1 class="fw-bold m-0">Discount Offers</h1></div>
    )
}

export default AgreementFilterBar